import React from 'react';
import ReactPlayer from 'react-player';
export default ReactPlayer;
